<template>
    <ls-panel class="ls-border-all" :hide-divider="true">
        <div class="grid__col-12 ls-margin--vertical">
            <div class="ls-loading-bar__container">
                <div class="ls-loading-bar__bar"></div>
                <div
                    class="ls-loading-bar__bar-fill"
                    :style="{
                        width: loadingBarWidth + '%',
                    }"
                ></div>

                <p
                    v-for="step in steps"
                    :key="step.text"
                    class="ls-color--gray--x-light"
                    :class="{
                        'ls-color--green--color-dodge':
                            isLawnStarter && (step.pending || step.complete),
                        'll-color-primary': isLawnLove && (step.pending || step.complete),
                        'primary-color': step.pending || step.complete,
                    }"
                >
                    {{ step.text
                    }}<!--
                 --><span v-if="step.complete"
                        >&nbsp;<i class="fa fa-fw fa-check-circle-o"></i></span
                    ><!--
                 --><span v-else-if="step.pending">&hellip;</span>
                </p>
            </div>
        </div>
    </ls-panel>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as types from '@/store/types';
import lsPanel from '@/components/original-mydot/panel/Panel.vue';
import brandMixin from '@/mixins/brand.mixin';

export default {
    components: {
        lsPanel,
    },
    mixins: [brandMixin],
    data() {
        return {
            currentStep: 0,
            loadingBarWidth: 0,
            steps: [
                {
                    text: 'Analyzing lot',
                    pending: true,
                    complete: false,
                },
                {
                    text: 'Locating providers',
                    pending: false,
                    complete: false,
                },
                {
                    text: 'Calculating price',
                    pending: false,
                    complete: false,
                },
                {
                    text: 'Finalizing quote',
                    pending: false,
                    complete: false,
                },
            ],
        };
    },

    computed: {
        ...mapState(['loading']),
    },

    methods: {
        ...mapActions({
            goToQuotedOrderRoute: types.LOADING__GO_TO_QUOTED_ORDER_ROUTE,
        }),

        incrementStep() {
            if (this.currentStep < this.steps.length) {
                if (this.steps[this.currentStep - 1]) {
                    this.steps[this.currentStep - 1].pending = false;
                    this.steps[this.currentStep - 1].complete = true;
                }
                this.steps[this.currentStep].pending = true;
                this.currentStep += 1;
            } else {
                // we've gotten to last step of animation
                // attempt to go to order route if it exists,
                // if no route name is set yet, request is still pending
                // keep animating 50% empty distance each interval
                this.goToQuotedOrderRoute();
            }

            this.determineLoadingBarWidth({ maxStepWidth: 100 / this.steps.length });
            this.incrementStepTimeout = setTimeout(this.incrementStep, 1000);
        },

        determineLoadingBarWidth({ maxStepWidth }) {
            const emptySectionWidth = 100 - this.loadingBarWidth;
            const halfEmptyWidth = emptySectionWidth * 0.5;

            this.loadingBarWidth += halfEmptyWidth > maxStepWidth ? maxStepWidth : halfEmptyWidth;
        },
    },

    mounted() {
        // ensures we give component time to initialize with width 0 for first step rendering
        setTimeout(this.incrementStep, 100);
    },

    destroyed() {
        clearTimeout(this.incrementStepTimeout);
    },
};
</script>

<style lang="scss" scoped>
.ls-loading-bar__container {
    width: 100%;
    position: relative;
    padding-top: 44px; // height of bar
}

.ls-loading-bar__bar {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    height: 44px;
    width: 100%;

    border: 1px solid palette(gray, 'x-light');
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.4), inset 0 -1px 3px 0 palette(white);
    border-radius: 3px;
}

.ls-loading-bar__bar-fill {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: palette(green, 'color-dodge');
    width: 0;
    height: 44px;
    border-radius: 3px;

    transition: width 1s ease-in-out;
}

.themed-app {
    .ls-loading-bar__bar {
        border-color: palette(gray, 'x-light');
        box-shadow: inset 0 1px 3px 0 rgba($theme-color-black, 0.4),
            inset 0 -1px 3px 0 palette($theme-color-white);
    }

    .ls-loading-bar__bar-fill {
        background-color: $theme-color-primary;
    }
    .primary-color {
        color: $theme-color-primary !important;
    }
}
</style>
